/* JOLI POT, fiches par occasion : aperçu du pot à l'échelle de la taille choisie (assets/jp-occasion-apercu.js, 24/10/2026).
   Chargé par snippets/jp-occasion-etapes.liquid. Le configurateur (assets/jp-configurateur.js, inchangé) garde le bloc d'aperçu, sa légende,
   son exemple réel et ses déclencheurs (message, taille, coupelle, cœur, signature, police chargée) ; à chaque dessin, ce script le refait
   aussitôt (avant l'affichage) avec la règle des fiches d'occasion, où le message est le même pour les 3 tailles :
   le dessin du pot ne change pas de taille, donc plus le pot est petit, plus le message prend de place (peu de marge) ;
   plus le pot est grand, plus il y a d'espace autour (marges à gauche, à droite, en haut et en bas).
   8 cm : message le plus grand relativement ; 11 cm : intermédiaire ; 13 cm : le plus petit relativement (rapport 8 / taille).
   Même pot que le configurateur (Joli pot blanc, bord terracotta, viewBox 200 x 200), même police (Sacramento), même courbe des lignes. */
(function () {
  var form = document.querySelector('form.jp-produit-form.jp-mode-occasion');
  if (!form) return;
  var K = {};
  try { K = JSON.parse(document.getElementById('jp-config').textContent); } catch (e) {}
  var options = K.options || [];
  function pos(mot) { for (var i = 0; i < options.length; i++) if (String(options[i]).toLowerCase().indexOf(mot) > -1) return i + 1; return 0; }
  var P_TAILLE = pos('taille'), P_COUP = pos('coupelle');
  function valeur(p) {
    if (!p) return '';
    var r = form.querySelector('.SizeSwatch__Radio[data-option-position="' + p + '"]:checked, .ColorSwatch__Radio[data-option-position="' + p + '"]:checked');
    return r ? r.value : '';
  }

  /* ===== Réglages de l'échelle (dessin de 200 x 200) =====
     r = 8 / taille : 1 pour 8 cm, 0,73 pour 11 cm, 0,62 pour 13 cm.
     Marges du message sur la face du pot (gauche et droite, haut et bas) et taille maximale des lettres, proportionnelles à r. */
  var ECHELLE = { margeX: [5, 34], margeY: [3, 28], lettres: 21, mini: 6 };
  function cadre(cm) {
    var r = 8 / (cm || 11);
    r = Math.max(0.5, Math.min(1, r));
    return { mx: ECHELLE.margeX[0] + (1 - r) * ECHELLE.margeX[1], my: ECHELLE.margeY[0] + (1 - r) * ECHELLE.margeY[1], cap: ECHELLE.lettres * r };
  }
  /* Pot du configurateur : face de 88 de large en haut (y 76), 66 en bas (y 164) ; zone d'écriture de y 80 à y 158 */
  var TOP = 76, H = 88, G0 = 56, D0 = 144, PENTE = 11, HAUT = 80, BAS = 158;
  function bords(y) { var dx = (y - TOP) * PENTE / H; return { g: G0 + dx, d: D0 - dx }; }

  var POL = "Sacramento, 'Brush Script MT', cursive", ctx = null;
  function largeur(t) {
    if (!ctx) { try { ctx = document.createElement('canvas').getContext('2d'); } catch (e) {} }
    if (!ctx) return t.length * 0.42;
    ctx.font = '10px ' + POL; return ctx.measureText(t).width / 10;
  }
  function coupes(m, k) {
    var res = [];
    (function r(d, k2, acc) {
      if (k2 === 1) { res.push(acc.concat([m.slice(d).join(' ')])); return; }
      for (var i = d + 1; i <= m.length - k2 + 1; i++) r(i, k2 - 1, acc.concat([m.slice(d, i).join(' ')]));
    })(0, k, []);
    return res;
  }
  /* Coupure équilibrée, comme le configurateur : le moins de lignes possible (3 au plus), longueurs proches, pas de petit mot en fin de ligne */
  var LIES = ['pour','et','de','du','des','à','au','aux','le','la','les','un','une','en','que','qui','mon','ma','mes','ton','ta','tes','son','sa','ses','avec','sans','sur','par','dans','ou','mais','nos','vos','notre','votre','ce','cette'];
  function equilibrer(ligne, larg, fs, forcer) {
    var m = ligne.split(/\s+/).filter(Boolean); if (!m.length) return [];
    var secours = null, secoursMax = Infinity;
    for (var k = 1; k <= Math.min(3, m.length); k++) {
      var choix = null, cout = Infinity;
      coupes(m, k).forEach(function (l) {
        var ws = l.map(function (x) { return largeur(x) * fs; }), mx = Math.max.apply(null, ws);
        if (mx < secoursMax) { secoursMax = mx; secours = l; }
        if (mx > larg) return;
        var moy = ws.reduce(function (a, b) { return a + b; }, 0) / k;
        var c = mx + ws.reduce(function (a, b) { return a + Math.abs(b - moy); }, 0) * 0.3;
        if (k > 1 && m.length > k && l[k - 1].indexOf(' ') < 0) c += larg;
        for (var z = 0; z < k - 1; z++) { var dern = l[z].split(' ').pop().toLowerCase(); if (LIES.indexOf(dern) > -1 || /['’]$/.test(dern)) c += larg * 0.6; }
        if (c < cout) { cout = c; choix = l; }
      });
      if (choix) return choix;
    }
    return forcer ? secours : null;
  }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  var COEUR_D = 'c-1.2-1.2-6-4.2-6-7.2 0-1.9 1.2-3.1 3.1-3.1 1.2 0 2.2.7 2.9 1.9.7-1.2 1.7-1.9 2.9-1.9 1.9 0 3.1 1.2 3.1 3.1 0 3-4.8 6-6 7.2z', NS = 0;

  function svg() {
    var t = document.getElementById('votre-texte-personnalise'), sgEl = document.getElementById('jp-ap-sig');
    var v = t ? t.value.replace(/\r/g, '').trim() : '', sg = sgEl ? sgEl.value.trim() : '';
    if (!v) return '';
    var cm = +((valeur(P_TAILLE).match(/\d+/) || [0])[0]) || 0, z = cadre(cm);
    var coupelle = /avec/i.test(valeur(P_COUP));
    var coeur = !(document.getElementById('jp-sans-coeur') || {}).checked;
    var brut = v.split('\n').map(function (x) { return x.trim(); }).filter(Boolean).slice(0, 6);
    var haut = HAUT + z.my, bas = BAS - z.my, fs, lh, lignes = [], ech, ecart, fsS, total, ok = false;
    for (fs = z.cap; fs >= ECHELLE.mini; fs -= 0.5) {
      var dernier = fs - 0.5 < ECHELLE.mini;
      lh = fs * 0.98;
      ech = Math.max(0.3, Math.min(0.8, fs / 28));
      ecart = coeur ? Math.max(2.5, fs * 0.4) : 0;
      fsS = sg ? Math.min(fs * 0.62, 13) : 0;
      var yMil = (haut + bas) / 2, lm = bords(yMil).d - bords(yMil).g - 2 * z.mx;
      lignes = []; ok = true;
      brut.forEach(function (b) { var lb = equilibrer(b, lm, fs, dernier); if (!lb) ok = false; else lb.forEach(function (x) { lignes.push(x); }); });
      if (!ok) continue;
      total = lignes.length * lh + (coeur ? ecart + 10.3 * ech : 0) + (sg ? fsS + 3 : 0);
      if (total > bas - haut && !dernier) { ok = false; continue; }
      var y = haut + (bas - haut - total) / 2 + lh * 0.72;
      for (var k = 0; k < lignes.length; k++) { var bd = bords(y + k * lh); if (largeur(lignes[k]) * fs > bd.d - bd.g - 2 * z.mx) { ok = false; break; } }
      if (ok && sg && largeur(sg) * fsS > lm) ok = false;
      if (ok || dernier) break;
    }
    var y0 = haut + (bas - haut - total) / 2 + lh * 0.72, id = 'jpoeap' + (++NS), s = '';
    s += '<svg data-jpoe="1" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="' + esc(v) + '"><defs>';
    lignes.forEach(function (x, k) { var yy = y0 + k * lh, bd = bords(yy); s += '<path id="' + id + k + '" d="M' + (bd.g - 6).toFixed(1) + ' ' + yy.toFixed(1) + ' Q100 ' + (yy + 4).toFixed(1) + ' ' + (bd.d + 6).toFixed(1) + ' ' + yy.toFixed(1) + '"/>'; });
    s += '</defs>';
    if (coupelle) s += '<ellipse cx="100" cy="172" rx="66" ry="9" fill="#b9644f"/><rect x="36" y="161" width="128" height="10" rx="3" fill="#ad523f"/>';
    s += '<path d="M56 76h88l-11 88H67z" fill="#fff" stroke="#e6ddd2"/><path d="M56 76h88l-1 7H57z" fill="#000" opacity=".05"/><rect x="47" y="58" width="106" height="20" rx="3" fill="#ad513f"/>';
    var pol = POL.replace(/"/g, '');
    lignes.forEach(function (x, k) {
      s += '<text font-family="' + pol + '" font-size="' + fs.toFixed(1) + '" font-weight="700" fill="#1d1a17" text-anchor="middle"><textPath href="#' + id + k + '" startOffset="50%">' + esc(x) + '</textPath></text>';
    });
    var yb = y0 + (lignes.length - 1) * lh + fs * 0.32;
    if (coeur) { yb += ecart + 10.3 * ech; s += '<path transform="translate(100 ' + yb.toFixed(1) + ') scale(' + ech.toFixed(3) + ') translate(-100 0)" d="M100 0' + COEUR_D + '" fill="#c8102e"/>'; }
    if (sg) { yb += fsS + 2; s += '<text x="100" y="' + yb.toFixed(1) + '" font-family="' + pol + '" font-size="' + fsS.toFixed(1) + '" fill="#1d1a17" text-anchor="middle">' + esc(sg) + '</text>'; }
    return s + '</svg>';
  }

  /* Le configurateur vient de dessiner : on remplace son dessin par celui à l'échelle (dans le même temps de rendu, sans clignotement) */
  var cible = null, enCours = false;
  function redessiner() {
    if (enCours || !cible || cible.querySelector('svg[data-jpoe]') || !cible.firstChild) return;
    enCours = true;
    try { var s = svg(); if (s) cible.innerHTML = s; } catch (e) {}
    enCours = false;
  }
  function brancher() {
    var c = form.querySelector('.jp-ap .jp-ap__svg');
    if (!c || c === cible) return !!c;
    cible = c;
    new MutationObserver(redessiner).observe(c, { childList: true });
    redessiner();
    return true;
  }
  if (!brancher() && window.MutationObserver) {
    var obs = new MutationObserver(function () { if (brancher()) obs.disconnect(); });
    obs.observe(form, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 15000);
  }
})();
